import React from "react";

export default function Timeline() {
  return (
    <div className="flex justify-center">
      <div
        className="flex flex-col w-[1440px] h-[751px] px-24 pb-32 pt-6 "
        style={{ backgroundImage: "url('/icons/Timeline/Rectangle.png')" }}
      >
        <img
          className="self-center"
          src="/icons/Timeline/headingTimeLine.png"
        />
        <div className="timeline-body ">
          <div className="flex gap-10 pt-11 text-justify justify-between">
            <h2 className="text-white  font-normal text-lg ">
              Became a strategic partner of P&G, offering recruitment and POSM
              services in FMCG
            </h2>
            <h2 className="text-white font-normal text-lg ">
              Achieved ISO 9001-2015 certification and expanded to Hai Phong and
              Bac Ninh
            </h2>
            <h2 className="text-white font-normal text-lg ">
              Partnered with LG, Masan, and Heineken, providing services for over
              10 years
            </h2>
            <h2 className="text-white font-normal text-lg ">
              Partnered with a key Korean company, achieving over 2,000 billion
              VND in revenue
            </h2>
          </div>
          <div className="pt-[57px]  relative">
            <img src="/icons/Timeline/tree.svg"></img>
            <div className="text-center w-[168px] h-14 -left-9  absolute top-16">
              <h2 className=" font-extrabold text-[23px] text-[#EB2027]">
                2009
              </h2>
              <h2 className="text-white font-extrabold text-[20px] ">ESTABLISHMENT</h2>
            </div>
            <div className="text-center w-[168px] h-14 left-[138px] top-[233px]  absolute ">
              <h2 className=" font-extrabold text-[23px] text-[#EB2027]">
                2011
              </h2>
              <h2 className="text-white font-extrabold text-[20px] ">PARTNERSHIP</h2>
            </div>
            <div className="text-center w-[168px] h-14 left-[290px] top-16  absolute ">
              <h2 className=" font-extrabold text-[23px] text-[#EB2027]">
                2013
              </h2>
              <h2 className="text-white font-extrabold text-[20px] ">EXPANSION</h2>
            </div>
            <div className="text-center w-[168px] h-14 left-[446px] top-[233px]  absolute ">
              <h2 className=" font-extrabold text-[23px] text-[#EB2027]">
                2015
              </h2>
              <h2 className="text-white font-extrabold text-[20px] ">PARTNERSHIP</h2>
            </div>
            <div className="text-center w-[168px] h-14 left-[574px]  top-16  absolute ">
              <h2 className=" font-extrabold text-[23px] text-[#EB2027]">
                2016
              </h2>
              <h2 className="text-white font-extrabold text-[20px] ">DIGITALIZATION</h2>
            </div>
            <div className="text-center w-[168px] h-14 left-[743px] top-[233px]  absolute ">
              <h2 className=" font-extrabold text-[23px] text-[#EB2027]">
                2020
              </h2>
              <h2 className="text-white font-extrabold text-[20px] ">PARTNERSHIP</h2>
            </div>
            <div className="text-center w-[168px] h-14 left-[884px]  top-16  absolute ">
              <h2 className=" font-extrabold text-[23px] text-[#EB2027]">
                2021
              </h2>
              <h2 className="text-white font-extrabold text-[20px] ">LEADERSHIP</h2>
            </div>
            <div className="text-center w-[168px] h-14 left-[1037px] top-[233px]  absolute ">
              <h2 className=" font-extrabold text-[23px] text-[#EB2027]">
                2023
              </h2>
              <h2 className="text-white font-extrabold text-[20px] ">GROWTH</h2>
            </div>
          </div>
          <div className="flex gap-10 pt-11 text-justify justify-between">
            <h2 className="text-white font-normal text-lg ">
              Spiral Company was founded with a focus on HR services and more
              than 10 employees
            </h2>
            <h2 className="text-white font-normal text-lg ">
              Expanded into manufacturing outsourcing, hitting 100 billion VND
              in revenue
            </h2>
            <h2 className="text-white font-normal text-lg ">
              Integrated digital technology and grew to over 10,000 project
              staff nationwide
            </h2>
            <h2 className="text-white font-normal text-lg ">
              Became the leading service provider for VMI and major electronics
              customers
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
}
